import { __ } from 'locale';
import React from 'react';
import store from 'store/index';
import Util from 'utility';

export default class TaskEvaluator  // extends Component
{
    constructor(callbacks) {
        //super(props);
        this.callbacks = callbacks;
        this.showTaskListDDDInfo = this.showTaskListDDDInfo.bind(this);
    }

    showTaskListDDDInfo(taskListDDDInfo, id, type, e) {
        this.callbacks['dddInfo'](taskListDDDInfo, id, type);
    }

    evaluate(parameters) 
    {
        const data = store.getState();
        const taskData = data.lectureTaskData;
        const lectureInfo = parameters.lectureInfo;


        const taskListMeals = [];
        const taskListMealsOk = [];
        const taskListUndesirableFoodsUsed = [];
        const taskListNumberOfFoods = [];
        const taskListNumberOfFoodsOk = [];
        const taskListDDDSorted = [];
        const taskListDDDSortedOk = [];
        const taskListDDDInfo = [];
        
        return {
            'taskListMeals': taskListMeals,
            'taskListMealsOk': taskListMealsOk,
            'taskListUndesirableFoodsUsed': taskListUndesirableFoodsUsed,
            'taskListNumberOfFoods': taskListNumberOfFoods,
            'taskListNumberOfFoodsOk': taskListNumberOfFoodsOk,
            'taskListDDD': taskListDDDSorted,
            'taskListDDDOk': taskListDDDSortedOk,
            'taskListDDDInfo': taskListDDDInfo,
        };

    }
}
